import {TableColumn} from "../../../interfaces/table/table-column";
import {TableColumnType} from "../../../enums/table-column-type";
import {TemplateRef} from "@angular/core";

export enum AssetTableColumn {
  SerialNumber = 'serial_number',
  AssetNumber = 'asset_number',
  AssetModel = 'full_asset_model',
  Location = 'location',
  LastPm = 'last_pm',
  NextPm = 'next_pm',
  NextPmStatusColor = 'next_pm_status_color',
  LastBatteryReplacement = 'last_battery_replacement',
  NextBatteryReplacement = 'next_battery_replacement'
}

export function constructAssetColumns(
  serialNumberColumnTmp: TemplateRef<any>,
  nextPmColumnTmp: TemplateRef<any>
): TableColumn[] {
  return [
    {
      columnId: AssetTableColumn.SerialNumber,
      header: 'Serial Number',
      type: TableColumnType.Template,
      template: serialNumberColumnTmp,
      sortable: true
    },
    {
      columnId: AssetTableColumn.AssetNumber,
      header: 'Asset #',
      type: TableColumnType.Text,
      sortable: true
    },
    {
      columnId: AssetTableColumn.AssetModel,
      header: 'Make / Model / Type',
      type: TableColumnType.Text,
      sortable: true
    },
    {
      columnId: AssetTableColumn.Location,
      header: 'Location',
      type: TableColumnType.Text,
      sortable: true
    },
    {
      columnId: AssetTableColumn.LastPm,
      header: 'Last Service',
      type: TableColumnType.Text,
      sortable: true
    },
    {
      columnId: AssetTableColumn.NextPm,
      header: 'Next Service Due',
      type: TableColumnType.Template,
      template: nextPmColumnTmp,
      sortable: true
    },
    {
      columnId: AssetTableColumn.LastBatteryReplacement,
      header: 'Last Battery Repl.',
      type: TableColumnType.Text,
      sortable: true
    },
    {
      columnId: AssetTableColumn.NextBatteryReplacement,
      header: 'Next Battery Repl.',
      type: TableColumnType.Text,
      sortable: true
    },
  ];
}
